// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBrandByPath } from "@insite/client-framework/Services/BrandService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrandByPath";

/**
 * XNG-Changes
 * https://xngage.atlassian.net/browse/STNRS-479
 */
export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        const brand = await getBrandByPath(props.parameter);
        props.apiResult = brand;
    } catch (error) {
        if (error?.status === 404) {
            /**
             * XNG-Changes
             * STNRS-479: redirect to 404 page when "Is Excluded from Brands" custom settings enable
             */
            typeof window !== "undefined" && window.location.replace("/NotFoundErrorPage");
            return;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
